import React, { useState, useCallback } from 'react';
import Confirmation from './Confirmation.js';
import StartLTIExercise from './StartLTIExercise.js';
import { isScorableLti } from './utils.js';

function getInitialPhase(material) {
    if (isScorableLti(material))
        return 'confirmation';
    return 'start';
}
function LtiExerciseModal({ id = 'lti-exercise-modal', material, tokenAccessor, onClose, translations, module, platformName, ltipsUrl, studioLanguage, headerElement, isOwner, analyticsData, studioGroup, }) {
    const [phase, setPhase] = useState(getInitialPhase(material));
    const onConfirm = useCallback(() => setPhase('start'), []);
    if (phase === 'confirmation' && isScorableLti(material)) {
        return (React.createElement(Confirmation, { id: id, material: material, onConfirm: onConfirm, tokenAccessor: tokenAccessor, onClose: onClose, translations: translations.confirmationModals, isOwner: isOwner, studioGroup: studioGroup }));
    }
    return (React.createElement(StartLTIExercise, { id: id, headerElement: headerElement, onClose: onClose, tokenAccessor: tokenAccessor, translations: translations.exerciseModal, material: material, module: module, platformName: platformName, ltipsUrl: ltipsUrl, studioLanguage: studioLanguage, isOwner: isOwner, analyticsData: analyticsData, studioGroup: studioGroup }));
}

export { LtiExerciseModal };
